// --- Helper Functions ---
const defaultSelectedCountry = 'US';

let countrySelector = null;
let languageSelector = null;
let popup = null;

const {
  availableCountries, shopifyLocaleCountry, shopifyLocaleLanguage, shopifyLocaleMarket,
} = window;

const languageFlagMap = {
  en: 'us',
  fr: 'fr',
  es: 'es',
  de: 'de',
  it: 'it',
  nl: 'nl',
  ar: 'sa',
  zh: 'cn',
  ja: 'jp',
};
const defaultLanguageByCountry = {
  es: 'es',
  at: 'de',
  ca: 'en',
};
const defaultLanguageByMarket = {
  us: 'en',
  fr: 'fr',
  de: 'de',
  be: 'fr',
  sa: 'ar',
  it: 'it',
  nl: 'nl',
  ch: 'de',
  int: 'en',
};

function getFlagImgTag(code, alt = '', size = 24) {
  const codeLc = code.toLowerCase();
  const src = `https://flagcdn.com/${size}x${Math.round(size * 0.75)}/${codeLc}.png`;
  const srcset = `https://flagcdn.com/${size * 2}x${Math.round(size * 2 * 0.75)}/${codeLc}.png 2x`;
  return `<img src="${src}" srcset="${srcset}" width="${size}" height="${Math.round(size * 0.75)}" class="flag-icon" alt="${alt} flag" style="vertical-align:middle;margin-right:8px;" />`;
}

/* eslint-disable */
function initTomSelects(initCountry, initLanguage) {
  // Country selector
  if (initCountry && countrySelector && !countrySelector.tomselect) {
    new TomSelect(countrySelector, {
      render: {
        option(data, escape) {
          return `<div>${data.flagImg}${escape(data.text)}</div>`;
        },
        item(data, escape) {
          return `<div>${data.flagImg}${escape(data.text)}</div>`;
        },
      },
      onInitialize() {
        this.options = this.options || {};
        for (const option of this.input.options) {
          const flag = option.dataset.flag || '';
          const { value } = option;
          if (value) {
            this.options[value] = {
              value,
              text: option.textContent,
              flagImg: getFlagImgTag(value, value),
            };
          }
        }
        this.refreshOptions(false);
        this.input.style.visibility = 'visible';
        this.wrapper.classList.add('country-selector-wrapper');
      },
    });
  }

  // Language selector
  if (initLanguage && languageSelector && !languageSelector.tomselect) {
    new TomSelect(languageSelector, {
      render: {
        option(data, escape) {
          return `<div>${data.flagImg}${escape(data.text)}</div>`;
        },
        item(data, escape) {
          return `<div>${data.flagImg}${escape(data.text)}</div>`;
        },
      },
      onInitialize() {
        this.input.classList.remove('select-hidden');
        this.wrapper.classList.add('language-selector-wrapper');
      },
    });
  }
}
/* eslint-disable */

function setSelectedCountrySelector(selectedCountry) {
  if (!countrySelector || !selectedCountry) return;
  countrySelector.tomselect?.setValue(selectedCountry.toUpperCase(), true);
}

function setSelectedLanguageSelector(selectedLanguage) {
  if (!languageSelector || !selectedLanguage) return;
  languageSelector.tomselect?.setValue(selectedLanguage, true);
}

function measureTextWidth(text, font = '16px Inter, sans-serif') {
  const canvas = measureTextWidth.canvas || (measureTextWidth.canvas = document.createElement('canvas'));
  const context = canvas.getContext('2d');
  context.font = font;
  return context.measureText(text).width;
}

function calculateMaxOptionWidth() {
  let longestText = '';
  for (const country of availableCountries) {
    const text = country.name;
    if (text.length > longestText.length) longestText = text;
    for (const lang of country.languages) {
      if (lang.name.length > longestText.length) longestText = lang.name;
    }
  }
  const measuredWidth = measureTextWidth(longestText, '16px Inter, sans-serif');
  return measuredWidth + 90; // Add padding/flag spacing
}

function positionDropdownSafely(form, trigger, options = {}) {
  const formEl = form;
  const triggerEl = trigger;

  const config = {
    edgePadding: options.edgePadding || 12,
    debug: options.debug || false
  };

  // Reset positioning
  formEl.style.left = '0px'; // Start from a known position
  formEl.style.transform = '';

  // Force reflow
  formEl.offsetHeight;

  const formRect = formEl.getBoundingClientRect();
  const triggerRect = triggerEl.getBoundingClientRect();
  const viewportWidth = window.innerWidth;

  const formWidth = formRect.width;
  const triggerCenter = triggerRect.left + (triggerRect.width / 2);

  // Where we want the dropdown's left edge to be (to center trigger within dropdown)
  const idealDropdownLeft = triggerCenter - (formWidth / 2);

  if (config.debug) {
    console.log("Current dropdown left (at 0px):", formRect.left);
    console.log("Trigger center:", triggerCenter);
    console.log("Dropdown width:", formWidth);
    console.log("Want dropdown left at:", idealDropdownLeft);
  }

  let targetLeft;

  // Check if ideal position fits
  if (idealDropdownLeft >= config.edgePadding &&
      (idealDropdownLeft + formWidth) <= (viewportWidth - config.edgePadding)) {
    targetLeft = idealDropdownLeft;
    if (config.debug) console.log("Using centered position");
  } else {
    // Use edge positioning
    if (idealDropdownLeft < config.edgePadding) {
      targetLeft = config.edgePadding;
      if (config.debug) console.log("Using left edge position");
    } else {
      targetLeft = viewportWidth - config.edgePadding - formWidth;
      if (config.debug) console.log("Using right edge position");
    }
  }

  // Calculate how much to move from current position
  const adjustment = targetLeft - formRect.left;
  formEl.style.left = `${adjustment}px`;

  if (config.debug) {
    console.log("Moving dropdown by:", adjustment, "pixels");

    setTimeout(() => {
      const finalRect = formEl.getBoundingClientRect();
      const dropdownCenter = finalRect.left + (finalRect.width / 2);
      console.log("Final dropdown left:", finalRect.left);
      console.log("Final dropdown center:", dropdownCenter);
      console.log("Target was trigger center:", triggerCenter);
      console.log("Centered correctly:", Math.abs(triggerCenter - dropdownCenter) < 2);
    }, 10);
  }
}

function getRedirectPath(selectedMarket, selectedLanguageCode) {
  const { pathname, search, hash } = window.location;
  let localePrefix = '';
  if (selectedMarket === 'us') {
    localePrefix = selectedLanguageCode === 'en' ? '' : `/${selectedLanguageCode}`;
  } else if (selectedMarket === 'int') {
    localePrefix = `/${selectedLanguageCode}-int`;
  } else {
    localePrefix = `/${selectedLanguageCode.toLowerCase()}-${selectedMarket.toLowerCase()}`;
  }
  const pathWithoutLocale = pathname.replace(/^\/([a-z]{2}(-[a-z]{2,3})?)(?=\/|$)/i, '');
  const newPath = `${localePrefix}${pathWithoutLocale}${search}${hash}`;
  return newPath || '/';
}

function updateTriggerFlags(countryCode, languageCode) {
  const countryFlagEl = document.querySelector('.localization-trigger-country-flag');
  const languageFlagEl = document.querySelector('.localization-trigger-language-flag');
  const langFlagCode = languageFlagMap[languageCode.toLowerCase()] || 'us';
  if (countryFlagEl) countryFlagEl.innerHTML = getFlagImgTag(countryCode, countryCode);
  if (languageFlagEl) languageFlagEl.innerHTML = getFlagImgTag(langFlagCode, languageCode);
}

async function updateLanguageOptions() {
  const selectedIso = countrySelector.value;
  const selectedObj = availableCountries.find((c) => c.iso_code === selectedIso);
  const languages = selectedObj ? selectedObj.languages : [];
  const marketHandle = selectedObj ? selectedObj.market : null;
  const defaultLangCode = defaultLanguageByCountry[selectedIso.toLowerCase()]
    || defaultLanguageByMarket[marketHandle?.toLowerCase()]
    || languages[0]?.iso_code;

  // Destroy existing TomSelect instance completely
  if (languageSelector.tomselect) {
    languageSelector.tomselect.destroy();
    languageSelector.tomselect = null;
  }

  // Reinitialize with fresh state
  initTomSelects(false, true);
  const ts = languageSelector.tomselect;

  // Add new options
  for (const lang of languages) {
    const flagCode = languageFlagMap[lang.iso_code.toLowerCase()] || 'us';
    ts.addOption({
      value: lang.iso_code,
      text: lang.name,
      flagImg: getFlagImgTag(flagCode, lang.iso_code),
    });
  }

  ts.refreshOptions(false);
  if (defaultLangCode) ts.setValue(defaultLangCode);
}

function setDetectedCountry(countryCode) {
  let isDetectedCountryFound = false;
  const option = Array.from(countrySelector.options).find(
    (opt) => opt.value.toUpperCase() === countryCode.toUpperCase()
  );
  if (option) {
    setSelectedCountrySelector(countryCode);
    isDetectedCountryFound = true;
  } else {
    setSelectedCountrySelector(defaultSelectedCountry);
  }
  return isDetectedCountryFound
}

async function updateCountryDetection(data) {
  const countryCode = data.countryCode || '';
  const countryName = data.countryName || '';
  const isDetectedCountryFound = setDetectedCountry(countryCode);
  const detectionTextEl = document.getElementById('detection-country');
  if (detectionTextEl && countryName) detectionTextEl.textContent = `${countryName}.`;
  if (!isDetectedCountryFound) {
    document.getElementById('splash-page-second-line-text').style.display = 'none';
    document.getElementById('splash-page-not-found-text').style.display = 'block';
  }
  await updateLanguageOptions();
  const selectedCountry = countrySelector.tomselect.getValue();
  const selectedLanguage = languageSelector.tomselect?.getValue?.() || languageSelector.value;
  updateTriggerFlags(selectedCountry, selectedLanguage);
}

function isDetectedCountryDifferentFromShopifyLocale(geoData) {
  return geoData && geoData.countryCode.toLowerCase() !== shopifyLocaleCountry;
}

function isSelectedCountryDifferentFromShopifyLocale(selected) {
  if (!selected) return false;
  // const [languageCode, marketHandle, countryCode] = selected.split('-');
  const countryCode = selected.split('-').pop();
  const isCountryDifferent = countryCode && countryCode.toLowerCase() !== shopifyLocaleCountry.toLowerCase();
  // const isLanguageDifferent = languageCode && languageCode.toLowerCase() !== shopifyLocaleLanguage.toLowerCase();
  return isCountryDifferent;
}

function getForm() {
  return document.querySelector('.localization-form');
}

function getFormWrapper() {
  return document.querySelector('.localization-form-wrapper');
}

function getPopup() {
  popup = document.querySelector('.country-popup-overlay');
  if (popup) {
    return popup;
  }

  // Create popup HTML if it doesn't exist
  popup = document.createElement('div');
  popup.className = 'country-popup-overlay';
  popup.style.display = 'flex';

  popup.innerHTML = `
    <div class="country-popup">
      <button class="country-popup-close-x" aria-label="Close">&times;</button>
      <h2 class="country-popup-title">${window.translations.locale_selector.popup.title}</h2>
      <p class="country-popup-subtitle">${window.translations.locale_selector.popup.subtitle}</p>
      <p class="country-popup-subtitle-country-not-found">${window.translations.locale_selector.popup.subtitle_country_not_found}</p>
      <div class="country-popup-selector-wrapper"></div>
    </div>
  `;

  // Handle close
  popup.querySelector('.country-popup-close-x').onclick = closePopup;
  // popup.querySelector('.country-popup-close').onclick = closePopup;

  // change form class
  getForm().classList.remove('localization-form-header');
  getForm().classList.add('localization-form-popup');

  document.body.appendChild(popup);

  return popup;
}

function isLocalePopupClosed() {
  return localStorage.getItem('localePopupClosed');
}

async function closePopup() {
  popup.style.display = 'none';

  // Move the form back to its original wrapper
  const form = getForm();
  form.classList.add('localization-form-header');
  form.classList.remove('localization-form-popup');
  getFormWrapper().appendChild(form);

  localStorage.setItem('localePopupClosed', true);

  setSelectedCountrySelector(shopifyLocaleCountry);

  await updateLanguageOptions();
  setSelectedLanguageSelector(shopifyLocaleLanguage);

  // If the user closed the popup without selecting - treat it like he selected the current shopify locale
  localStorage.setItem('selectedCountryAndLanguage', `${shopifyLocaleLanguage}-${shopifyLocaleMarket}-${shopifyLocaleCountry.toLowerCase()}`);
};


function showPopup(countryCode, languageCode) {
  if (isLocalePopupClosed()) {
    return; // Don't show popup if it was closed before
  }
  popup = getPopup()

  // Move the form into the popup
  const selectorWrapper = popup.querySelector('.country-popup-selector-wrapper');
  const form = getForm();

  selectorWrapper.innerHTML = '';
  selectorWrapper.appendChild(form);

  if (countrySelector && countrySelector.tomselect) {
    setSelectedCountrySelector(countryCode);
  }

  if (languageSelector && languageSelector.tomselect) {
    setSelectedLanguageSelector(languageCode);
  }

  // check for detected country and set correct text
  const isDetectedCountryFound = setDetectedCountry(countryCode);

  if (!isDetectedCountryFound) {
    document.querySelector('.country-popup-subtitle-country-not-found').style.display = 'block';
    document.querySelector('.country-popup-subtitle').style.display = 'none';
  }

  popup.style.display = 'flex';
}

async function updateLocaleSelectorData(data) {
  const isSplashPageLocaleForm = getForm().classList.contains('localization-form-splash');
  if (!isSplashPageLocaleForm && isDetectedCountryDifferentFromShopifyLocale(data)) {
    showPopup(data.countryCode);
    updateTriggerFlags(shopifyLocaleCountry, shopifyLocaleLanguage);
  } else {
    await updateCountryDetection(data);
  }
  await updateLanguageOptions();
}

// --- DOMContentLoaded ---
document.addEventListener('DOMContentLoaded', async () => {
  const formWrapper = document.querySelector('.localization-form-wrapper');
  const form = formWrapper.querySelector('.localization-form');
  const selectorSubmitButton = form.querySelector('.submit-selection');
  const splashPlaceholder = document.getElementById('splash-locale-selector-placeholder');
  const headerPlaceholder = document.getElementById('header-locale-selector-placeholder');
  const splashPage = document.getElementById('splash-page');

  // Check if localStorage has old selectedCountryAndLanguage format - if so remove it
  // New format is: language-market-countryCode
  // so we can detect the selected country and not just the market
  // Old format was: language-countryCode
  if (/^[a-zA-Z]+-[a-zA-Z]+$/.test(localStorage.getItem('selectedCountryAndLanguage'))) {
    localStorage.removeItem('selectedCountryAndLanguage');
  }

  const localStorageSelectedlocale = localStorage.getItem('selectedCountryAndLanguage');

  countrySelector = form.querySelector('.country-selector');
  languageSelector = form.querySelector('.language-selector');

  // TomSelect for country
  let countrySelectorTs = countrySelector.tomselect;
  if (!countrySelectorTs) {
    initTomSelects(true, false);
  }

  // Set form width
  const idealFormWidth = calculateMaxOptionWidth();
  form.style.width = `${idealFormWidth}px`;

  // Country selector change updates language options
  countrySelector.addEventListener('change', () => {
    updateLanguageOptions();
  });

  // Splash/header logic
  const shouldShowSplash = splashPage && !localStorageSelectedlocale;
  if (shouldShowSplash) {
    splashPage.style.display = 'flex';
    if (splashPlaceholder && formWrapper) {
      form.classList.add('localization-form-splash');
      splashPlaceholder.appendChild(formWrapper);
    }
  } else {
    if (splashPage) splashPage.remove();
    if (headerPlaceholder && formWrapper) {
      form.classList.add('localization-form-header');
      headerPlaceholder.appendChild(formWrapper);
    }
    const trigger = document.getElementById('localization-trigger');
    if (trigger && formWrapper && form) {
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        form.classList.toggle('show');
        positionDropdownSafely(form, trigger, { debug: false });
      });
      document.addEventListener('click', (e) => {
        if (!form.contains(e.target) && !trigger.contains(e.target)) {
          form.classList.remove('show');
        }
      });
    }
  }

  // Submit button logic
  selectorSubmitButton.addEventListener('click', (event) => {
    event.preventDefault();
    const selectedCountryCode = countrySelector.tomselect.getValue();
    const selectedLanguageCode = languageSelector.tomselect?.getValue?.() || languageSelector.value;
    const selectedOption = countrySelector.querySelector(`option[value="${selectedCountryCode}"]`);
    const selectedMarket = selectedOption?.getAttribute('data-market');
    let redirectPath = getRedirectPath(selectedMarket, selectedLanguageCode);

    // Example: /collections/new-women or /fr-be/collections/new-women, /de-de/collections/new-women, etc.
    const url = new URL(redirectPath, window.location.origin);
    if (/^(\/[a-z]{2}-[a-z]{2,3})?\/collections\//.test(redirectPath)) {
      // Reset all filter/sort params on collection URLs if changes country or language
      url.search = '';
    } else {
      // remove country param (that cuases issues with the redirect) from all other URLs (with or without locale prefix)
      url.searchParams.delete('country');
    }
    redirectPath = url.pathname + url.search + url.hash;

    document.getElementById('country_code_input').value = selectedCountryCode;
    document.getElementById('language_code_input').value = selectedLanguageCode;
    const returnToInput = document.querySelector('input[name="return_to"]');
    if (returnToInput) returnToInput.value = redirectPath;
    localStorage.setItem('selectedCountryAndLanguage', `${selectedLanguageCode}-${selectedMarket}-${selectedCountryCode.toLowerCase()}`);
    getForm().submit();
  });

  // Initial population and detection
  if (localStorageSelectedlocale) {
    if (!isLocalePopupClosed() && isSelectedCountryDifferentFromShopifyLocale(localStorageSelectedlocale)) {
      const localStorageCountryCode = localStorageSelectedlocale.split('-').pop();
      showPopup(localStorageCountryCode);
    } else {
      setSelectedCountrySelector(shopifyLocaleCountry);
      setSelectedLanguageSelector(shopifyLocaleLanguage);
    }
    await updateLanguageOptions();
    updateTriggerFlags(shopifyLocaleCountry, shopifyLocaleLanguage);
  } else {
    const geoData = localStorage.getItem('geoData');
    if (geoData) {
      const data = JSON.parse(geoData);
      await updateLocaleSelectorData(data);
    } else {
      fetch('https://free.freeipapi.com/api/json/')
        .then((res) => res.json())
        .then(async (data) => {
          localStorage.setItem('geoData', JSON.stringify(data));
          await updateLocaleSelectorData(data);
        })
        .catch((err) => {
          console.error('fetch geo IP err', err);
          setSelectedCountrySelector(defaultSelectedCountry);
          updateLanguageOptions();
        });
    }
  }
});
